<template>
  <section id="products" class="sections-products">
    <div class="sections-products__container container">
      <div class="sections-products__body">
        <div
          class="sections-products__wrapper sections-products__wrapper--content"
        >
          <CSpriteIcon
            v-for="item in 20"
            :key="item"
            class="sections-products__icon sections-products__icon--plus"
            :class="`sections-products__icon--plus--${item}`"
            name="plus"
          />

          <div
            class="sections-products__wrapper sections-products__wrapper--content-body"
          >
            <UiCaptionUnderline
              caption="Products"
              class="sections-products__caption"
            />

            <div class="sections-products__products">
              <div class="sections-products__product">
                <div class="sections-products__abbreviation">
                  <span
                    class="sections-products__font sections-products__font--abbreviation"
                  >
                    IRM:
                  </span>
                </div>

                <div class="sections-products__name">
                  <span
                    class="sections-products__font sections-products__font--name"
                  >
                    Interactive<br />
                    Routes Map
                  </span>
                </div>

                <div
                  class="sections-products__wrapper sections-products__wrapper--product-image-wrapper"
                >
                  <CPicture
                    name="product-1"
                    class="sections-products__image sections-products__image--product-1"
                  />
                </div>

                <div class="sections-products__description">
                  <span
                    class="sections-products__font sections-products__font--description"
                  >
                    See your journeys unfold with live updates, vehicle
                    positions, and passenger insights.
                  </span>
                </div>
              </div>

              <div class="sections-products__product">
                <div class="sections-products__abbreviation">
                  <span
                    class="sections-products__font sections-products__font--abbreviation"
                  >
                    TAM:
                  </span>
                </div>

                <div class="sections-products__name">
                  <span
                    class="sections-products__font sections-products__font--name"
                  >
                    Timetable & Availability Monitoring
                  </span>
                </div>

                <div
                  class="sections-products__wrapper sections-products__wrapper--product-image-wrapper"
                >
                  <CPicture
                    name="product-2"
                    class="sections-products__image sections-products__image--product-1"
                  />
                </div>

                <div class="sections-products__description">
                  <span
                    class="sections-products__font sections-products__font--description"
                  >
                    Stay informed effortlessly — real-time data on schedules,
                    seat availability, and fares.
                  </span>
                </div>
              </div>

              <div class="sections-products__product">
                <div class="sections-products__abbreviation">
                  <span
                    class="sections-products__font sections-products__font--abbreviation"
                  >
                    CC:
                  </span>
                </div>

                <div class="sections-products__name">
                  <span
                    class="sections-products__font sections-products__font--name"
                  >
                    Communication<br />
                    Center
                  </span>
                </div>

                <div
                  class="sections-products__wrapper sections-products__wrapper--product-image-wrapper"
                >
                  <CPicture
                    name="product-3"
                    class="sections-products__image sections-products__image--product-1"
                  />
                </div>

                <div class="sections-products__description">
                  <span
                    class="sections-products__font sections-products__font--description"
                  >
                    Keep conversations flowing easily between you and your
                    customers at every step.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts"></script>
<style scoped lang="scss">
.sections-products {
  &__font {
    display: block;

    &--abbreviation {
      font-size: em(48);
      font-weight: 700;
      line-height: 115%;

      @include media-breakpoint-down(md) {
        font-size: em(38);
      }
    }

    &--name {
      font-size: em(21);
      font-weight: 700;
      line-height: 115%;

      @include media-breakpoint-down(md) {
        font-size: em(17);
      }
    }

    &--description {
      font-family: $font-family-second;
      font-size: em(16);
      font-weight: 500;
      line-height: 115%;

      @include media-breakpoint-down(md) {
        font-size: em(13);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(14);
      }
    }
  }

  &__icon {
    &--plus {
      position: absolute;
      width: em(40);
      height: em(40);
      pointer-events: none;
      opacity: 0.5;

      &--1 {
        top: 0;
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(-4);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--2 {
        top: em(60);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(45);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--3 {
        top: em(100);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(77);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--4 {
        top: em(246);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(192);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(200);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--5 {
        top: em(578);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(458);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(464);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--6 {
        top: em(676);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(520);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(547);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--7 {
        top: em(100);
        left: em(332);

        @include media-breakpoint-down(md) {
          top: em(1040);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1078);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--8 {
        top: em(246);
        left: em(332);

        @include media-breakpoint-down(md) {
          top: em(1155);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1195);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--9 {
        top: em(578);
        left: em(332);

        @include media-breakpoint-down(md) {
          top: em(1419);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1461);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--10 {
        top: em(676);
        left: em(332);

        @include media-breakpoint-down(md) {
          top: em(1497);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1545);
          left: 50%;
          transform: translateX(calc(-50% - #{em(134)}));
        }
      }

      &--11 {
        top: em(100);
        left: em(668);

        @include media-breakpoint-down(md) {
          top: em(-4);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--12 {
        top: em(246);
        left: em(668);

        @include media-breakpoint-down(md) {
          top: em(45);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--13 {
        top: em(578);
        left: em(668);

        @include media-breakpoint-down(md) {
          top: em(77);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--14 {
        top: em(676);
        left: em(668);

        @include media-breakpoint-down(md) {
          top: em(192);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(md) {
          top: em(199);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--15 {
        top: 0;
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(458);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(465);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--16 {
        top: em(60);
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(520);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(548);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--17 {
        top: em(100);
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(1040);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1077);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--18 {
        top: em(246);
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(1155);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1195);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--19 {
        top: em(578);
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(1419);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1461);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }

      &--20 {
        top: em(676);
        left: em(1000);

        @include media-breakpoint-down(md) {
          top: em(1497);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }

        @include media-breakpoint-down(sm) {
          top: em(1545);
          left: 50%;
          transform: translateX(calc(-50% + #{em(134)}));
        }
      }
    }
  }

  &__container {
    @include media-breakpoint-down(md) {
      max-width: em(448);
      padding: 0;
    }
  }

  &__body {
    padding: 0 em(40);

    @include media-breakpoint-down(md) {
      padding: 0 em(0);
    }
  }

  &__wrapper {
    &--content {
      position: relative;
      padding: em(40);
      background: url('#{$images-path}/red_map_background.webp') center / cover
        no-repeat;

      @supports not (-webkit-touch-callout: none) {
        background-attachment: fixed;
      }

      @include media-breakpoint-down(md) {
        padding: em(35) 0;
      }
    }

    &--content-body {
      width: 100%;
      height: 100%;

      @include media-breakpoint-down(md) {
        width: em(300);
        padding: 0 em(30);
        margin: 0 auto;
      }
    }

    &--product-image-wrapper {
      width: em(296);
      height: em(296);
      padding: em(15);
      margin-top: em(40);
      border: em(6) dashed $color-white;

      @include media-breakpoint-down(md) {
        width: 100%;
        height: em(236);
        padding: em(9);
        margin-top: em(31);
        border: em(4) dashed $color-white;
      }
    }
  }

  &__caption {
  }

  &__products {
    display: flex;
    justify-content: space-between;
    margin-top: em(82);

    @include media-breakpoint-down(md) {
      flex-direction: column;
      margin-top: em(64);
    }
  }

  &__product {
    width: em(296);

    &:not(:last-child) {
      @include media-breakpoint-down(md) {
        margin-bottom: em(65);
      }
    }

    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }

  &__abbreviation {
    color: $text-dark-on-red;
  }

  &__name {
    color: $text-dark-on-red;
  }

  &__description {
    margin-top: em(40);
    color: $text-dark-on-red;

    @include media-breakpoint-down(md) {
      margin-top: em(30);
    }

    @include media-breakpoint-down(sm) {
      width: 100%;
      max-width: em(230);
      margin-top: em(35);
    }
  }

  &__image {
    &--product-1 {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
